angular.module('components.media.FileController', [
  'global',
  'components.media.FileService'
])

/**
 * The FileController manages scope logic and user
 * interaction.
 *
 * @class FileController
 * @constructor
 * @module components.media.FileController
 */
.controller('FileController', [
  '$scope',
  function ($scope) {
    'use strict';

    $scope.formattedModel = {};

    /**
     * Method executes the initialization process.
     *
     * @private
     */
    function initialize() {
      $scope.formattedModel = _.clone($scope.model);
    }

    initialize();
  }
]);
